import React, { useState } from 'react';
import {
  DEFAULT_OBSERVABLE_TYPE,
  OPENCTI_OBSERVABLE_TYPES,
} from '../config/openctiObservables';
import CreateIndicatorFields from './CreateIndicatorFields';

function AddIndicatorForm({ caseId, actorId, onCreated, disabled = false }) {
  const [key, setKey] = useState(0);

  return (
    <div className="entity-inline-form" style={{ marginBottom: 'var(--spacing-lg)' }}>
      <CreateIndicatorFields
        key={key}
        initialType={DEFAULT_OBSERVABLE_TYPE}
        caseId={caseId}
        actorId={actorId}
        disabled={disabled}
        submitLabel="Add indicator"
        onCreated={(ioc) => {
          setKey((n) => n + 1);
          onCreated?.(ioc);
        }}
      />
      <p style={{ marginTop: '8px', fontSize: '12px', color: 'var(--hdp-text-muted)' }}>
        {OPENCTI_OBSERVABLE_TYPES.length} OpenCTI observable types available.
      </p>
    </div>
  );
}

export default AddIndicatorForm;
